import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { Progress, Card, Alert, Spin } from "antd"; // برای نمایش لودینگ

const GuestGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div
        className="h-screen flex justify-center"
        // display="flex"
        // justifyContent="center"
        // alignItems="center"
        // minHeight="100vh"
      >
        <Spin tip=" ... در حال ورود به سیستم">
          <Alert title="در حال ورود به سیستم " type="info" />
        </Spin>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard-page" />;
  }

  return <>{children}</>;
};

export default GuestGuard;
